<template>
  <div class="app-container" uk-height-viewport="expand: true">
      <div class="uk-width-1-1">
        <home-content></home-content>
      </div>
  </div>
</template>
<script>
  import HomeContent from './home-content'
  import HomeSearchBar from '../navigation-bar/home-search-bar'
  import { mapGetters, mapActions, mapMutations } from 'vuex'

  export default {
    name: 'home',
    components: {
      HomeSearchBar,
      HomeContent
    },
    data() {
      return {
        show: false
      }
    },
    computed: {
      ...mapGetters(['content', 'filters'])
    },
    methods: {
      ...mapActions(['setDefaultAuthorFilter', 'setDefaultKeywordFilter', 'setDefaultFilters', 'cleanSetSearchCriteria']),
      ...mapMutations(['setPendingModerationResourceDefaults', 'setApprovedModerationResourceDefaults', 'setDeclinedModerationResourceDefaults', 'setStrands', 'setSearchStrands'])
    },
    created() {
      this.setDefaultFilters(this.filters)
      this.setDefaultAuthorFilter()
      this.setDefaultKeywordFilter()
      this.cleanSetSearchCriteria(null)
      this.setPendingModerationResourceDefaults()
      this.setApprovedModerationResourceDefaults()
      this.setDeclinedModerationResourceDefaults()
      this.setStrands(null)
      this.setSearchStrands(null)
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>
<style lang="scss" scoped>
  @import '../../styles/breakpoints';
  @media screen and (max-width: $breakpoint-medium) {
    .app-container {
      width: 100%;
    }
  }
</style>
